import React, { PropsWithChildren } from "react";
import { Tooltip } from "@mui/material";
import classNames from "classnames";

import { Button } from "./toolbar.styles";

interface IProps {
  active?: boolean;
  disabled?: boolean;
  title: string;
  onClick(): void;
}

const ToolbarButton: React.FC<PropsWithChildren<IProps>> = ({
  active = false,
  disabled = false,
  children,
  title,
  onClick,
  ...props
}: PropsWithChildren<IProps>) => {
  return (
    <Tooltip title={title} placement="right">
      <span>
        <Button className={classNames({ "Mui-selected": active })} onClick={onClick} disabled={disabled} {...props}>
          {children}
        </Button>
      </span>
    </Tooltip>
  );
};

export default ToolbarButton;
